import 'whatwg-fetch';
import $ from 'jquery';

const SOURCE = 'https://www.rcsdk8.org';

export default class ProfileDirectory {
  constructor(element) {
    this.$element = $(element);
    this.success = this.success.bind(this);
    this.fail = this.fail.bind(this);

    // Grab the dynamic bits to make each directory unique to the site.
    const page = this.$element.attr('data-page');
    const url = new Request(`${SOURCE}/${page}`);
    const options = {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
    };

    // Request the appropriate school directory from the district site.
    fetch(url, options)
      .then(this.validate)
      .then(this.success)
      .catch(this.fail);
  }

  // Validate response from our request.
  /* eslint-disable class-methods-use-this */
  validate(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.text();
  }

  // Display an error message if the request failed.
  fail(error) {
    this.error = error;
    this.$element.html(`There was an error loading the content, click <a href="${SOURCE}/staff-directory">here</a> to see the staff directory on the main district site.`);
  }

  // Pass off the response text to the parse it for our output.
  success(result) {
    // Extract the target content which is within the posts block.
    const $content = $(result).find('.posts.block');
    // Transition link destinations from relative to absolute.
    $content.find('a').filter('[href^="/"]').each((i, component) => {
      $(component).attr('href', (ii, value) => `${SOURCE}${value}`);
    });
    // Transition link destinations from relative to absolute.
    $content.find('img').filter('[src^="/"]').each((i, component) => {
      $(component).attr('src', (ii, value) => `${SOURCE}${value}`);
    });
    // Add/remove helper class styling.
    $content.addClass('profile-directory').removeClass('fiw-25 fif-rt');
    // Append directory block proceeding the overview block.
    $content.insertAfter(this.$element.closest('.block'));
    // Hide load status.
    this.$element.addClass('done');
  }
}



// WEBPACK FOOTER //
// ./DistrictProfiles.js